import { services } from 'services/base';
import { HandleErrorBoundaryService, MainErrorItem } from 'types';
import { convertExceptionToJson, logger, registerQueue } from 'utils';

type ErrorState = {
  main: MainErrorItem[];
  dialog: MainErrorItem[];
};

const SERVICE_PREFIX = 'appFrame.error';
const serviceMethods = {
  addItem: 'addError',
  removeItem: 'closeError',
  removeAll: 'closeAllErrors',
  onItemChange: 'onErrorChange',
  onQueueChange: 'onErrorsChange',
  getItem: 'getError',
  getQueue: 'getErrors',
};

const initErrorServices = () => {
  const { registerService } = services;
  const state: ErrorState = {
    main: [],
    dialog: [],
  };

  registerQueue({
    state,
    stateKey: 'main',
    initValue: [],
    servicePrefix: `${SERVICE_PREFIX}.main`,
    serviceMethods,
  });

  registerQueue({
    state,
    stateKey: 'dialog',
    initValue: [],
    servicePrefix: `${SERVICE_PREFIX}.dialog`,
    serviceMethods,
  });

  registerService<HandleErrorBoundaryService>(`${SERVICE_PREFIX}.handleErrorBoundary`, (React: any, err: Error) => {
    logger.error('Unexpected internal error in application module:', err);
    services.appFrame.error.main.addError({
      title: 'errors.internal_module_error.title',
      message: 'errors.internal_module_error.message',
      details: {
        type: 'INTERNAL_MODULE_ERROR',
        timestamp: new Date(),
        error: convertExceptionToJson(err),
      },
      actions: [
        {
          id: 'reopen',
          text: 'errors.internal_module_error.actions.reopen',
          onClick: () => {
            services.appFrame.error.main.closeError();
          },
        },
      ],
    });

    // we don't use React jsx as we want to use the "external" React instance for rendering
    return React.createElement(() => null);
  });
};

export default initErrorServices;
